import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';

interface SetQuestionVoidParams {
  questionId: string;
  /** true = void (all options correct, everyone who answered wins); false = un-void. */
  voided: boolean;
  reason?: string;
}

export interface SetQuestionVoidResponse {
  success: boolean;
  questionId: string;
  voided: boolean;
  /**
   * True when the question was graded (voided → all options correct, or un-voided → real
   * winner). False on un-void when the question couldn't be auto-graded and was reset to
   * ungraded — the admin must grade it manually.
   */
  regraded?: boolean;
  /**
   * True when the pickem LEADERBOARD was re-scored (points + ranks). Payouts are NOT
   * recalculated here — run "Recalculate Prizes" for that.
   */
  scored?: boolean;
  /** Present when scoring was skipped (e.g. already scoring, or paid payouts exist). */
  scoringSkippedReason?: string;
}

export const setQuestionVoid = async (
  params: SetQuestionVoidParams
): Promise<SetQuestionVoidResponse> => {
  return (apiClient as any).post(`/api/admin/live-scoring/question/${params.questionId}/void`, {
    voided: params.voided,
    reason: params.reason,
  });
};

export const useSetQuestionVoidMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setQuestionVoid,
    onSuccess: () => {
      // Voiding re-grades + re-scores on the backend (option is_correct + points change).
      // Refresh the questions list so the void badge, "HAS ANSWER" column and scoring gate
      // reflect the new state.
      queryClient.invalidateQueries({
        queryKey: queryKeys.questions.all,
      });
    },
  });
};
